import React from "react";
import calendarIcon from "../../../assets/package/calendar.png";
import checkIcon from "../../../assets/package/check.png";
import crossIcon from "../../../assets/package/cross-small.png";
import globeIcon from "../../../assets/package/globe.png";
import infinityIcon from "../../../assets/package/infinity.png";
import "./OfferCard.css";

const OfferCard = ({ id, gigabytes, duration, price, currency, selected = false, topUpAvailable, onToggle }) => {
  const isUnlimited = gigabytes === -1;

  const gbClassName = "offer-card-gb" + (isUnlimited ? " offer-card-gb--unlimited" : "");
  const cardClassName = "offer-card" + (selected ? " offer-card--selected" : "");

  return (
    <div className={cardClassName} onClick={onToggle}>
      <div className="offer-card-header">
        <div className="offer-card-gb-wrapper">
          {/*{!isUnlimited && <img src={globeIcon} alt="" className="offer-card-gb-icon" />}*/}
          {isUnlimited && <img src={infinityIcon} alt="" className="offer-card-gb-icon" />}
          <span className={gbClassName}>{isUnlimited ? "Unlimited Data" : `${gigabytes} GB`}</span>
        </div>
        <button
          type="button"
          className={"offer-card-radio" + (selected ? " offer-card-radio--checked" : "")}
          onClick={(e) => {
            e.stopPropagation();
            onToggle();
          }}
          aria-pressed={selected}
        >
          <span className="offer-card-radio-circle" />
        </button>
      </div>

      <div className="offer-card-main">
        <span className="offer-card-topup">
          <img src={topUpAvailable ? checkIcon : crossIcon} alt="" className="offer-card-topup-icon" />
          <span className="offer-card-topup-text">{topUpAvailable ? "Top-up available" : "Top-up not available"}</span>
        </span>
        <span className="offer-card-days">
          <img src={calendarIcon} alt="" className="offer-card-days-icon" />
          {duration} days
        </span>
      </div>

      <div className="offer-card-price">
        <span className="offer-card-price-value">
          {price.toFixed(2)} {currency}
        </span>
      </div>
    </div>
  );
};

export default OfferCard;
